import * as React from "react";
import PropTypes from "prop-types";
import Tracker from "./Tracker";
import Context from "./Context";
export const TrackerProvider = ({
  projectRef,
  analytics,
  tracker,
  children
}) => {
  const context = tracker || new Tracker({
    projectRef,
    analytics
  });
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: context
  }, children);
};
const LogEventPropTypes = {
  logEvent: PropTypes.func.isRequired
};
TrackerProvider.propTypes = {
  children: PropTypes.node,
  projectRef: PropTypes.string,
  analytics: PropTypes.shape(LogEventPropTypes),
  tracker: PropTypes.shape({ ...LogEventPropTypes,
    setInterfaceId: PropTypes.func.isRequired
  })
};